var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-605.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5",
    transform: "translate(576.000000, 846.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc",
    transform: "translate(29.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#FF315B",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.95,14 L16.05,14 C13.8132468,14 12,15.8468254 12,18.125 L12,31.875 C12,34.1531746 13.8132468,36 16.05,36 L34.95,36 C37.1867532,36 39,34.1531746 39,31.875 L39,18.125 C39,15.8468254 37.1867532,14 34.95,14 Z M16.0036765,16.6829268 L34.9963235,16.6829268 C35.7455628,16.6829268 36.3529412,17.2835205 36.3529412,18.0243902 L36.3529412,19.3658537 L14.6470588,19.3658537 L14.6470588,18.0243902 C14.6470588,17.2835205 15.2544372,16.6829268 16.0036765,16.6829268 Z M34.9963235,33.3170732 L16.0036765,33.3170732 C15.2544372,33.3170732 14.6470588,32.6864499 14.6470588,31.9085366 L14.6470588,22.0487805 L36.3529412,22.0487805 L36.3529412,31.9085366 C36.3529412,32.6864499 35.7455628,33.3170732 34.9963235,33.3170732 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.28a497221e9bd6b30f6efc9bbc04c555.svg";
export { ForwardRef as ReactComponent };